export const APP_NAME = 'main-client';
